export default __webpack_public_path__ + "f64205acced308b2812daec9562168c1.png";